import { component } from "picoapp";

export default component((node, ctx) => {
  console.log("PrivacyForm component initialized on node:", node);
  node.addEventListener("submit", handleSubmit);
  const individualControl = node.querySelector(".js-individual-control");
  const stateSelector = node.querySelector('[name="states"]');
  const countrySelector = node.querySelector('[name="country"]');

  countrySelector.addEventListener("change", (e) => {
    const country = countrySelector.value;
    const stateDisabled = !(country === "United States");
    stateSelector.disabled = stateDisabled;
    if (stateDisabled) {
      stateSelector.value = "Not Applicable";
    } else {
      stateSelector.value = "";
    }
  });

  individualControl.addEventListener("change", (e) => {
    const val = e.target.value;
    const el = node.querySelector(".privacy-form-authorized-agent");
    const isHidden = val === "individual";
    el.setAttribute("aria-hidden", isHidden);
  });

  function validateEmailAddress(email) {
    return /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/gm.test(
      email
    );
  }

  function handleSubmit(event) {
    console.log("Form submit event triggered!");
    event.preventDefault();
    const data = new FormData(event.target);
    const email = data.get("_replyto");
    const confirmEmail = data.get("email");

    // Clear previous errors
    clearErrors();

    // Validate radio group selection
    const radioSelection = data.get("type-of-excercise");
    console.log("Validating radio selection:", radioSelection);
    if (!radioSelection) {
      console.log("Radio validation failed, showing error");
      showRadioError();
      return;
    }

    // Validate email format
    console.log("Validating email:", email);
    if (!validateEmailAddress(email)) {
      console.log("Email validation failed, showing error");
      showEmailError();
      return;
    }

    // Validate email match
    if (email !== confirmEmail) {
      showConfirmEmailError();
      return;
    }

    // Submit form
    fetch("https://formspree.io/f/xoqbnryk", {
      method: "post",
      body: data,
      headers: {
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          const wrapper = document.querySelector(".js-privacy-form-wrapper");
          const successMsg = document.querySelector(".js-privacy-form-success");
          wrapper.style.display = "none";
          successMsg.style.display = "";
          successMsg.scrollIntoView({
            behavior: "auto",
            block: "center",
            inline: "center",
          });
          event.target.reset();
        } else {
          showGenericError();
        }
      })
      .catch((e) => {
        showGenericError();
      });
  }

  function clearErrors() {
    // Clear radio error
    const radioError = node.querySelector(".js-radio-error");
    radioError.classList.add("hidden");

    // Clear email error
    const emailField = node.querySelector("#email-address");
    const emailError = node.querySelector(".js-email-error");
    emailField.classList.remove("border-error");
    emailError.classList.add("hidden");

    // Clear confirm email error
    const confirmEmailField = node.querySelector("#confirm-email-address");
    const confirmEmailError = node.querySelector(".js-confirm-email-error");
    confirmEmailField.classList.remove("border-error");
    confirmEmailError.classList.add("hidden");

    // Clear generic error
    const genericError = node.querySelector(".js-privacy-error");
    genericError.classList.add("hidden");
  }

  function showRadioError() {
    const radioError = node.querySelector(".js-radio-error");
    const firstRadio = node.querySelector('input[name="type-of-excercise"]');

    console.log("showRadioError called");
    console.log("radioError:", radioError);
    console.log("firstRadio:", firstRadio);

    if (radioError) {
      radioError.classList.remove("hidden");
      console.log("Radio error should be visible now");
    } else {
      console.error("Could not find radio error element");
    }

    // Focus on first radio button
    if (firstRadio) {
      firstRadio.focus();
    }

    // Clear error when any radio is selected
    const radioButtons = node.querySelectorAll(
      'input[name="type-of-excercise"]'
    );
    radioButtons.forEach((radio) => {
      radio.addEventListener(
        "change",
        () => {
          if (radioError) {
            radioError.classList.add("hidden");
          }
        },
        { once: true }
      );
    });
  }

  function showEmailError() {
    const emailField = node.querySelector("#email-address");
    const emailError = node.querySelector(".js-email-error");

    console.log("showEmailError called");
    console.log("emailField:", emailField);
    console.log("emailError:", emailError);

    if (emailField && emailError) {
      emailField.classList.add("border-error");
      emailError.classList.remove("hidden");
      emailField.focus();
      console.log("Error should be visible now");
    } else {
      console.error("Could not find email field or error element");
    }

    // Clear error on input
    if (emailField) {
      emailField.addEventListener(
        "input",
        () => {
          emailField.classList.remove("border-error");
          if (emailError) {
            emailError.classList.add("hidden");
          }
        },
        { once: true }
      );
    }
  }

  function showConfirmEmailError() {
    const confirmEmailField = node.querySelector("#confirm-email-address");
    const confirmEmailError = node.querySelector(".js-confirm-email-error");

    confirmEmailField.classList.add("border-error");
    confirmEmailError.classList.remove("hidden");
    confirmEmailField.focus();

    // Clear error on input
    confirmEmailField.addEventListener(
      "input",
      () => {
        confirmEmailField.classList.remove("border-error");
        confirmEmailError.classList.add("hidden");
      },
      { once: true }
    );
  }

  function showGenericError() {
    const genericError = node.querySelector(".js-privacy-error");
    genericError.classList.remove("hidden");
  }

  return (node) => {
    node.removeEventListener("submit", handleSubmit);
  };
});
